export const DataNames = {
  COMMENTS: 'COMMENTS',
  REACH: 'REACH',
  DATE: 'DATE',
  TIMES: 'TIMES',
};
